import React from "react";

import ErrorModalStatusContext from "contexts/ErrorModalStatusContext";

const useErrorModalStatusContext = () => React.useContext(ErrorModalStatusContext);

export default useErrorModalStatusContext;
